export class CounterPatternStrategy {
  generate(ctx, chord, oct, baseDegree, rand, bpb) {
    const pattern = [];
    const ctrOct = oct;
    const scaleLen = ctx.scale.length;
    const chordDegrees = ctx.chordToScaleDegrees(chord);
    const numNotes = 3 + Math.floor(rand() * 2);
    const beats = [];
    for (let i = 0; i < numNotes; i++) beats.push(0.5 + i * ((bpb - 0.5) / Math.max(numNotes - 1, 1)));
    let deg = baseDegree + 2;
    for (let i = 0; i < beats.length; i++) {
      const dir = rand() < 0.6 ? -1 : 1;
      deg += dir * (rand() < 0.7 ? 1 : 2);
      deg = Math.max(0, Math.min(deg, scaleLen * 2 - 1));
      if (i === Math.floor(beats.length / 2) && chordDegrees.length > 0) {
        deg = chordDegrees[Math.floor(rand() * chordDegrees.length)];
      }
      pattern.push({ beat: beats[i], note: ctx.noteFromDegree(deg, ctrOct), duration: 0.2 + rand() * 0.25 });
    }
    return pattern;
  }
}
